<template>
  <div
    class="container-fluid discovery-splash"
    v-bind:class="{ noSplash: searchActive, mobile: isMobile() }"
  >
    <div class="discovery-splash-background"></div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1
            class="text-center"
            v-bind:class="{ 
              //inActiveElement: searchActive 
            }"
            v-html="$t('discover.subtitle')"
          ></h1>
          <router-link v-if="!isLoggedIn" class="btn red-button start-now" :to="'/register'">
            {{ $t("discover.start_now") }}
          </router-link>
          <div v-else class="search-input" >
            <icon-search />
            <input
              v-model="query"
              @keydown.enter="search"
              type="text"
              class="form-control"
              :placeholder="$t('discover.search')"
            />
          </div>
        </div>
      </div>

      <browse-by-country
        :countries="countries"
        v-bind:class="{ inActiveElement: searchActive }"
        :selectedCountry="selectedCountry"
      />
    </div>

    <!-- <div class="container" v-if="searchActive">
      <div class="row" v-if="hits.length > 0">
        <vertical-card-search
          class="col-lg-2 col-md-3 col-sm-4 col-xs-6 col-6"
          v-for="hit in hits"
          :key="hit.objectID"
          :hit="hit"
        />
      </div>
      <div v-else>
        <h1>{{ $t("search.no_results") }}</h1>
      </div>
    </div> -->
  </div>
</template>

<script>
import IconSearch from "../icons/iconSearch.vue";
import BrowseByCountry from "../../components/discovery/BrowseByCountry.vue";
import algoliasearch from "algoliasearch";
import VerticalCardSearch from "@/components/landing/search/VerticalCardSearch.vue";
import { mapState } from "pinia";
import { UserStore } from "../../stores/userStore";
const client = algoliasearch("C1XB5XK87T", "691228d05e070e772a2994476e3ee194");
const index = client.initIndex("movies");
export default {
  name: "DiscoverySplash",
  components: { VerticalCardSearch, IconSearch, BrowseByCountry },
  props: {
    countries: {
      type: Array,
      default: () => [],
    },
    selectedCountry: {
      type: Object,
      required: false,
    }
  },
  computed: {
    ...mapState(UserStore, ["isLoggedIn"]),
    searchActive() {
      return this.query.length > 0;
    },
    noResults() {
      return this.$store.state.search.noResults;
    },
  },
  data() {
    return {
      query: "",
      hits: [],
    };
  },
  methods: {
    countrySelected(data) {
      this.$emit("countryselected", data);
    },
    search() {
      this.$emit("search", this.query);
    },
  },
};
</script>

<style lang="scss">
.discovery-splash {
  .discovery-splash-background {
    background: url("@/assets/img/discover/background.png") no-repeat center
      center;
    background-size: cover;
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    -webkit-mask-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(rgba(0, 0, 0, 1)),
      to(rgba(0, 0, 0, 0))
    );
    mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
  }

  position: relative;
  &.mobile {
    h1 {
      font-size: 1.8em;
      line-height: 1.8qem;
      padding: 2em 0 1em;
    }
    .search-input {
      width: 100%;
      input {
        padding: 1.5em 2em 1.5em 3em;
      }
    }
  }

  &.noSplash {
    background-image: none;
  }

  h1 {
    font-size: 3.5em;
    padding: 2em 0 1em;
  }

  .search-input {
    width: 80%;
    opacity: 0.9;
    max-width: 600px;
    margin: 0 auto;
    position: relative;
    border-radius: 16px;
    background: linear-gradient(to bottom right, #233452, #3f5782);
    padding: 0.5px;

    input {
      padding: 2.5em 4em;
      font-size: 0.9em;
      font-weight: lighter;
      color: #fff;
      border-radius: 16px;
      border: none;
      background: linear-gradient(
        1.64deg,
        #202b40 -6.14%,
        rgba(12, 17, 26, 0) 160.73%
      );
      &::placeholder {
        color: #fff;
      }
    }
    svg {
      position: absolute;
      top: 50%;
      left: 1em;
      transform: translateY(-50%);
      width: 1.5em;
      height: 1.5em;
      fill: #fff;
    }
  }

  .inActiveElement {
    height: 0;
    opacity: 0;
    transition: all 0.13s ease-in-out;
    padding: 0em;
    pointer-events: none;
    overflow: hidden;
  }

  .start-now{
    display: flex;
    text-align: center;
    justify-content: center;
    width: 100%;
    max-width: 600px;
    justify-self: center;
  }
}


@media (min-width: 1920px) {

  .discovery-splash {
    .search-input {
      max-width: 800px;
      input{
        font-size: 0.7vw;
        padding: 1em 3em;
      }
    }
  }
}

@media (min-width: 3840px) {

  .discovery-splash {
    .search-input {
      input{
        font-size: 1.8em;
      }
    }
  }
}



</style>
